module.exports = __webpack_public_path__ + "static/media/Pennum.7e4daab0.png";